import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "@environments/environment";
import { lastValueFrom } from "rxjs";
import { CurrentTenantService } from '@suvo-bi-users';

interface IMediaPaginationQuery {
  pageIndex: number;
  pageSize: number;
}

type MediaListSortActive = 'id' | 'createdAt';
type MediaListSortDirection = 'ASC' | 'DSC' | '';

interface IMediaSortQuery {
  active: MediaListSortActive;
  direction: MediaListSortDirection;
}

interface IMediaListQuery {
  pagination?: IMediaPaginationQuery;
  search?: string;
  sort?: IMediaSortQuery;
}

@Injectable()
export class MediaService {
  tenantId: string;

  constructor(
    private http: HttpClient,
    private currentTenantService: CurrentTenantService,
  ) {
    this.tenantId = this.currentTenantService.currentTenant()._id!;
  }

  listImageCodes(query?: IMediaListQuery) {
    const params: Record<string, string> = {};

    if (query?.pagination) {
      params.pagination = JSON.stringify(query.pagination);
    }

    if (query?.search) {
      params.search = query.search;
    }

    if (query?.sort) {
      params.sort = JSON.stringify(query.sort);
    }

    return lastValueFrom(
      this.http.get<string[]>(`${environment.mediaServiceApi}/list-library-items`, { params })
    )
  }

  buildImageUrl(imageId: string, variant: string = 'thumbnail') {
    return `${environment.mediaStaticAssets}/${this.tenantId}/${imageId}/${variant}`;
  }

  async uploadImageToLibrary(image: File) {
    const endpoint = `${environment.mediaServiceApi}/upload/image`;
    const formData: FormData = new FormData();
    formData.append('image', image, image.name);

    const data = await lastValueFrom(this.http.post<{ id: string }>(endpoint, formData));
    return data.id;
  }
}